import { Link } from "react-router-dom";
import { Header } from "../components/Header";

export const Home = () => {
    return (
        <>

            <div
                className='flex flex-col items-center justify-center'
                style={{ height: "calc(100% - 64px)" }}>
                <div
                    className='flex flex-row items-center justify-center gap-16'
                    style={{
                        width: "calc(100% - 120px)",
                        "@media (max-width: 1024px)": {
                            width: "calc(100% - 80px)",
                        },
                    }}>
                    <Link to='/staff' className='button-xl'>
                        <span>Staff</span>
                    </Link>
                    <Link to='/guest' className='button-xl'>
                        <span>Guest</span>
                    </Link>
                </div>
            </div>
        </>
    );
};
